import * as React from 'react';
import { NavigationIconWrapper } from './NavigationPanel.style';
import { OtherSportIcon } from 'src/ui/assets/icons/sports/OtherSportIcon';
import { QuestionIcon } from 'src/ui/assets/icons/other/QuestionIcon';
import { EighteenPlusIcon } from 'src/ui/assets/icons/other/EighteenPlusIcon';
import { ChatIcon } from 'src/ui/assets/icons/other/ChatIcon';
import { StarFillIcon } from 'src/domains/layouts/shared/assets/icons/StarFillIcon';
import { NavMenuVariantType } from 'src/domains/layouts/config/features/types';
import { AmericanFootballIcon } from 'src/ui/assets/icons/sports/AmericanFootballIcon';
import { BasketballIcon } from 'src/ui/assets/icons/sports/BasketballIcon';
import { BaseballIcon } from 'src/ui/assets/icons/sports/BaseballIcon';
import { BoxingIcon } from 'src/ui/assets/icons/sports/BoxingIcon';
import { CricketIcon } from 'src/ui/assets/icons/sports/CricketIcon';
import { DartsIcon } from 'src/ui/assets/icons/sports/DartsIcon';
import { FootballIcon } from 'src/ui/assets/icons/sports/FootballIcon';
import { GolfIcon } from 'src/ui/assets/icons/sports/GolfIcon';
import { GreyhoundRacingIcon } from 'src/ui/assets/icons/sports/GreyhoundRacingIcon';
import { HorseRacingIcon } from 'src/ui/assets/icons/sports/HorseRacingIcon';
import { MMAIcon } from 'src/ui/assets/icons/sports/MMAIcon';
import { PoliticsIcon } from 'src/ui/assets/icons/sports/PoliticsIcon';
import { RugbyLeagueIcon } from 'src/ui/assets/icons/sports/RugbyLeagueIcon';
import { TennisIcon } from 'src/ui/assets/icons/sports/TennisIcon';
import { CyclingIcon } from 'src/ui/assets/icons/sports/CyclingIcon';
import { FormulaOneIcon } from 'src/ui/assets/icons/sports/FormulaOneIcon';
import { GaelicHurlingIcon } from 'src/ui/assets/icons/sports/GaelicHurlingIcon';
import { IceHockeyIcon } from 'src/ui/assets/icons/sports/IceHockeyIcon';
import { RugbyUnionIcon } from 'src/ui/assets/icons/sports/RugbyUnionIcon';
import { SnookerIcon } from 'src/ui/assets/icons/sports/SnookerIcon';
import { VolleyballIcon } from 'src/ui/assets/icons/sports/VolleyballIcon';
import { GaelicFootballIcon } from 'src/ui/assets/icons/sports/GaelicFootball';
import { MotorSportIcon } from 'src/ui/assets/icons/sports/MotorSportsIcon';
import { WrestlingIcon } from 'src/ui/assets/icons/sports/WrestlingIcon';
import { AustralianRulesIcon } from 'src/ui/assets/icons/sports/AustralianRulesIcon';
import { AthleticsIcon } from 'src/ui/assets/icons/sports/AthleticsIcon';
import { BowlsIcon } from 'src/ui/assets/icons/sports/BowlsIcon';
import { ChristmasIcon } from 'src/ui/assets/icons/sports/ChristmasIcon';
import { EurovisionIcon } from 'src/ui/assets/icons/sports/EurovisionIcon';
import { FishingIcon } from 'src/ui/assets/icons/sports/FishingIcon';
import { HandBallIcon } from 'src/ui/assets/icons/sports/HandBallIcon';
import { OlympicsWinterIcon } from 'src/ui/assets/icons/sports/OlympicsWinterIcon';
import { OlympicsSummerIcon } from 'src/ui/assets/icons/sports/OlympicsSummerIcon';
import { PoolIcon } from 'src/ui/assets/icons/sports/PoolIcon';
import { RowingIcon } from 'src/ui/assets/icons/sports/RowingIcon';
import { SwimmingIcon } from 'src/ui/assets/icons/sports/SwimmingIcon';
import { NetBallIcon } from 'src/ui/assets/icons/sports/NetBallIcon';
import { AmericanFootballIcon as AmericanFootballSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/AmericanFootballIcon';
import { BaseballIcon as BaseballSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/BaseballIcon';
import { BasketballIcon as BasketballSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/BasketballIcon';
import { BoxingIcon as BoxingSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/BoxingIcon';
import { CricketIcon as CricketSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/CricketIcon';
import { CyclingIcon as CyclingSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/CyclingIcon';
import { DartsIcon as DartsSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/DartsIcon';
import { FootballIcon as FootballSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/FootballIcon';
import { GolfIcon as GolfSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/GolfIcon';
import { GreyhoundIcon as GreyhoundRacingSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/GreyhoundIcon';
import { HockeyIcon as IceHockeySecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/HockeyIcon';
import { HorseIcon as HorseRacingSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/HorseIcon';
import { MMAIcon as MMASecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/MMAIcon';
import { MotorSportsIcon as MotorSportSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/MotorSportsIcon';
import { RugbyIcon as RugbyUnionSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/RugbyIcon';
import { SnookerIcon as SnookerSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/SnookerIcon';
import { StarIcon as StarBoostsSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/StarIcon';
import { TennisIcon as TennisSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/TennisIcon';
import { VolleyballIcon as VolleyballSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/VolleyballIcon';
import { GlobeUKIcon as GlobeUKSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/GlobeUKIcon';
import { FaqIcon as FaqSecondaryIcon } from 'src/ui/assets/icons/sportsSecondary/FaqIcon';

export const renderSportIcon = (name: string | null, variant: NavMenuVariantType | null): JSX.Element => {
    const normalized = name?.trim().toLowerCase().replace(/[ .-]/g, '') ?? '';

    const secondarySportsIconMap: Record<string, React.ElementType> = {
        americanfootball: AmericanFootballIcon,
        australianrules: AustralianRulesIcon,
        athletics: AthleticsIcon,
        baseball: BaseballIcon,
        basketball: BasketballIcon,
        boxing: BoxingIcon,
        bowls: BowlsIcon,
        cricket: CricketIcon,
        cycling: CyclingIcon,
        christmas: ChristmasIcon,
        darts: DartsIcon,
        eurovision: EurovisionIcon,
        football: FootballIcon,
        formulaone: FormulaOneIcon,
        gaelicfootball: GaelicFootballIcon,
        gaelichurling: GaelicHurlingIcon,
        golf: GolfIcon,
        greyhoundracing: GreyhoundRacingIcon,
        fishing: FishingIcon,
        horseracing: HorseRacingIcon,
        handball: HandBallIcon,
        icehockey: IceHockeyIcon,
        mixedmartialarts: MMAIcon,
        motorsport: MotorSportIcon,
        netball: NetBallIcon,
        olympicswinter: OlympicsWinterIcon,
        olympicsummer: OlympicsSummerIcon,
        politics: PoliticsIcon,
        pool: PoolIcon,
        rugbyleague: RugbyLeagueIcon,
        rugbyunion: RugbyUnionIcon,
        rowing: RowingIcon,
        snooker: SnookerIcon,
        starboosts: StarFillIcon,
        tennis: TennisIcon,
        volleyball: VolleyballIcon,
        swimming: SwimmingIcon,
        wrestling: WrestlingIcon,
    };

    const tertiarySportsIconMap: Record<string, React.ElementType> = {
        americanfootball: AmericanFootballSecondaryIcon,
        australianrules: RugbyUnionSecondaryIcon,
        badminton: TennisSecondaryIcon,
        baseball: BaseballSecondaryIcon,
        basketball: BasketballSecondaryIcon,
        boxing: BoxingSecondaryIcon,
        cricket: CricketSecondaryIcon,
        cycling: CyclingSecondaryIcon,
        darts: DartsSecondaryIcon,
        esports: GlobeUKSecondaryIcon,
        esport: GlobeUKSecondaryIcon,
        faq: FaqSecondaryIcon,
        football: FootballSecondaryIcon,
        formulaone: MotorSportSecondaryIcon,
        gaelicfootball: VolleyballSecondaryIcon,
        gaelichurling: IceHockeySecondaryIcon,
        golf: GolfSecondaryIcon,
        greyhoundracing: GreyhoundRacingSecondaryIcon,
        handball: GlobeUKSecondaryIcon,
        horseracing: HorseRacingSecondaryIcon,
        icehockey: IceHockeySecondaryIcon,
        mixedmartialarts: MMASecondaryIcon,
        motorsport: MotorSportSecondaryIcon,
        olympics: GlobeUKSecondaryIcon,
        olympicssummer: GlobeUKSecondaryIcon,
        olympicswinter: GlobeUKSecondaryIcon,
        politics: GlobeUKSecondaryIcon,
        rugbyleague: RugbyUnionSecondaryIcon,
        rugbyunion: RugbyUnionSecondaryIcon,
        snooker: SnookerSecondaryIcon,
        starboosts: StarBoostsSecondaryIcon,
        tabletennis: TennisSecondaryIcon,
        'tv&specials': GlobeUKSecondaryIcon,
        tennis: TennisSecondaryIcon,
        tv: GlobeUKSecondaryIcon,
        tvspecials: GlobeUKSecondaryIcon,
        volleyball: VolleyballSecondaryIcon,
    };

    const commonIconMap: Record<string, React.ElementType> = {
        faq: QuestionIcon,
        safergambling: EighteenPlusIcon,
        traderchat: ChatIcon,
    };

    const sportIconMap = variant === NavMenuVariantType.TERTIARY ? tertiarySportsIconMap : secondarySportsIconMap;
    const IconComponent = sportIconMap[normalized] ?? commonIconMap[normalized];

    if (IconComponent !== undefined) {
        return (
            <NavigationIconWrapper
                key={normalized}
                isStarBoosts={normalized === 'starboosts'}
            >
                <IconComponent />
            </NavigationIconWrapper>
        );
    }

    return (
        <NavigationIconWrapper
            key={normalized}
            isStarBoosts={false}
        >
            <OtherSportIcon />
        </NavigationIconWrapper>
    );
};
